import { ReferentialKey } from 'api/referential';
import { useAppDispatch } from 'app/hooks';
import { GenericViewHeader } from 'back-office/shared/components/GenericViewHeader';
import { SimpleDashboardContent } from 'features/dashboard/DashboardContent';
import { getMultipleReferentialsByKeys } from 'features/referentials/slices/getMultipleReferentialsByKeysThunk';
import { Briefcase } from 'lucide-react';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

export default function PimsView() {
  const dispatch = useAppDispatch();

  // Référentiels du formulaire de création (plateforme en premier champ,
  // catégorie d'intermédiaire optionnelle).
  useEffect(() => {
    dispatch(getMultipleReferentialsByKeys([
      ReferentialKey.Plateforme,
    ]));
  }, [dispatch]);

  return (
    <SimpleDashboardContent>
      <GenericViewHeader
        title="PIM — Professionnels de l'Immobilier"
        icon={Briefcase}
      />
      <Outlet />
    </SimpleDashboardContent>
  );
}
